window.theme = window.theme || {};

theme.icons = {
  chevronLightLeft: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg>',
  chevronLightRight: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg>',
  chevronDown: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>'
};

// Lightbox
theme.fbOpts = { overlayColor: '#fff', padding: 1, margin: 60, overlayOpacity: 0.9 };
theme.lightbox_min_window_width = 768;
theme.lightbox_min_window_height = 580;

// declare before Sections
theme.checkForBannerBehindHeader = function(){
  jQuery(window).off('.bannerBehindHeader');
  var $banner = jQuery('.banner-under-header');
  if($banner.length) {
    jQuery('body').addClass('has-banner');
    jQuery(window).on('load.bannerBehindHeader scroll.bannerBehindHeader bannerBehindHeader.bannerBehindHeader', function(){
      jQuery('body').toggleClass('header-overlapping', jQuery(window).scrollTop() < $banner.outerHeight());
    }).trigger('bannerBehindHeader');
  } else {
    jQuery('body').removeClass('has-banner header-overlapping');
  }
}

theme.loadPageHeaderImage = function(target) {
  var $banner = jQuery('#page-banner', target);
  if($banner.length > 0) {
    $banner.imagesLoaded(function(e){
      jQuery('#page-banner').addClass('show-contents');
    });
    jQuery('#page-banner .fixed-height img', target).willFillParent({ closest: '.header-image-container, .slide', windowEvent: 'debouncedresize' });
  }
  // could have been removed
  theme.checkForBannerBehindHeader();
}

theme.unloadPageHeaderImage = function(target) {
  jQuery(window).off('.willFillParent');
}

theme.Sections = new function(){
  var _ = this;
  
  var sections = [];
  var instances = [];
  
  _.init = function(){
    jQuery(document).on('shopify:section:load', function(e){
      // load a new section
      var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
      if(target) {
        _.sectionLoad(target);
      }
    }).on('shopify:section:unload', function(e){
      // unload existing section
      var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
      if(target) {
        _.sectionUnload(target);
      }
    });
  }
  
  // register a type of section
  _.register = function(type, section){
    sections.push({ type: type, section: section });
    jQuery('[data-section-type="'+type+'"]').each(function(){
      _.sectionLoad(this);
    });
  }
  
  // load in a section
  _.sectionLoad = function(target){
    var target = target;
    var section = _._sectionForTarget(target);
    if(section !== false) {
      instances.push({
        target: target,
        section: section
      });
      section.onSectionLoad(target);
      jQuery(target).on('shopify:block:select', function(e){
        _._callWith(section, 'onBlockSelect', e.target);
      }).on('shopify:block:deselect', function(e){
        _._callWith(section, 'onBlockDeselect', e.target);
      });
    }
  }
  
  // unload a section
  _.sectionUnload = function(target){
    var instanceIndex = -1;
    for(var i=0; i<instances.length; i++) {
      if(instances[i].target == target) {
        instanceIndex = i;
      }
    }
    if(instanceIndex > -1) {
      jQuery(target).off('shopify:block:select shopify:block:deselect');
      _._callWith(instances[instanceIndex].section, 'onSectionUnload', target);
      instances.splice(instanceIndex);
    }
  }
  
  // helpers
  _._callWith = function(object, method, param) {
    if(typeof object[method] === 'function') {
      object[method](param);
    }
  }
  
  _._themeSectionTargetFromShopifySectionTarget = function(target){
    var $target = jQuery('[data-section-type]:first', target);
    if($target.length > 0) {
      return $target[0];
    } else {
      return false;
    }
  }
  
  _._sectionForTarget = function(target) {
    var type = jQuery(target).attr('data-section-type');
    for(var i=0; i<sections.length; i++) {
      if(sections[i].type == type) {
        return sections[i].section;
      }
    }
    return false;
  }
}

// Loading third party scripts
theme.scriptsLoaded = [];
theme.loadScriptOnce = function(src, callback) {
  if(theme.scriptsLoaded.indexOf(src) < 0) {
    theme.scriptsLoaded.push(src);
    var tag = document.createElement('script');
    tag.src = src;
    
    if(typeof callback == 'function') {
      if (tag.readyState) { // IE, incl. IE9
        tag.onreadystatechange = function() {
          if (tag.readyState == "loaded" || tag.readyState == "complete") {
            tag.onreadystatechange = null;
            callback();
          }
        };
      } else {
        tag.onload = function() { // Other browsers
          callback();
        };
      }
    }
    
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    return true;
  } else {
    if(typeof callback == 'function') {
      callback();
    }
    return false;
  }
}

// Manage videos
theme.VideoManager = new function(){
  var _ = this;
  
  // Youtube
  _.youtubeVars = {
    incrementor: 0,
    apiReady: false,
    videoData: {},
    toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)'
  };
  
  _.youtubeApiReady = function() {
    _.youtubeVars.apiReady = true;
    _._loadYoutubeVideos();
  }
  
  _._loadYoutubeVideos = function(container) {
    if(jQuery(_.youtubeVars.toProcessSelector, container).length) {
      if(_.youtubeVars.apiReady) {
        // play those videos
        jQuery(_.youtubeVars.toProcessSelector, container).addClass('video--init').each(function(){
          _.youtubeVars.incrementor++;
          var containerId = 'theme-yt-video-'+_.youtubeVars.incrementor;
          var videoElement = jQuery('<div>').attr('id', containerId).appendTo(this);
          var player = new YT.Player(containerId, {
            height: '390',
            width: '640',
            videoId: jQuery(this).data('video-id'),
            playerVars: {
              iv_load_policy: 3,
              modestbranding: 1,
              autoplay: !!jQuery(this).data('video-autoplay') ? 1 : 0,
              rel: 0
            },
            events: {
              onReady: _._onYoutubePlayerReady,
              onStateChange: _._onYoutubePlayerStateChange
            }
          });
          _.youtubeVars.videoData[player.h.id] = {
            id: containerId,
            container: this,
            videoElement: videoElement,
            player: player
          };
        });
      } else {
        // load api
        theme.loadScriptOnce('https://www.youtube.com/iframe_api');
      }
    }
  }
  
  _._onYoutubePlayerReady = function(event) {
    event.target.setPlaybackQuality('hd1080');
  }
       
  _._onYoutubePlayerStateChange = function(event) {
  }
    
  _._getYoutubeVideoData = function(event) {
    return _.youtubeVars.videoData[event.target.h.id];
  }
  
  _._unloadYoutubeVideos = function(container) {
    for(var dataKey in _.youtubeVars.videoData) {
      var data = _.youtubeVars.videoData[dataKey];
      if(jQuery(container).find(data.container).length) {
        data.player.destroy();
        delete _.youtubeVars.videoData[dataKey];
        return;
      }
    }
  }
  
  // Vimeo
  _.vimeoVars = {
    incrementor: 0,
    apiReady: false,
    videoData: {},
    toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)'
  };
  
  _.vimeoApiReady = function() {
    _.vimeoVars.apiReady = true;
    _._loadVimeoVideos();
  }
  
  _._loadVimeoVideos = function(container) {
    if(jQuery(_.vimeoVars.toProcessSelector, container).length) {
      if(_.vimeoVars.apiReady) {
        // play those videos
        jQuery(_.vimeoVars.toProcessSelector, container).addClass('video--init').each(function(){
          _.vimeoVars.incrementor++;
          var $this = jQuery(this);
          var containerId = 'theme-vi-video-'+_.vimeoVars.incrementor;
          var videoElement = jQuery('<div>').attr('id', containerId).appendTo(this);
          var autoplay = !!jQuery(this).data('video-autoplay');
          var player = new Vimeo.Player(containerId, {
            id: jQuery(this).data('video-id'),
            width: 640,
            loop: false,
            autoplay: autoplay
          });
          player.ready().then(function(){
            if(player.element && player.element.width && player.element.height) {
              var ratio = parseInt(player.element.height) / parseInt(player.element.width);
              $this.css('padding-bottom', (ratio*100) + '%');
            }
          });
          _.vimeoVars.videoData[containerId] = {
            id: containerId,
            container: this,
            videoElement: videoElement,
            player: player,
            autoPlay: autoplay
          };
        });
      } else {
        // load api
        theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function(){
          _.vimeoVars.apiReady = true;
          _._loadVimeoVideos();
        });
      }
    }
  }
  
  _._unloadVimeoVideos = function(container) {
    for(var dataKey in _.vimeoVars.videoData) {
      var data = _.vimeoVars.videoData[dataKey];
      if(jQuery(container).find(data.container).length) {
        data.player.unload();
        delete _.vimeoVars.videoData[dataKey];
        return;
      }
    }
  }
  
  // Compatibility with Sections
  this.onSectionLoad = function(container){
    _._loadYoutubeVideos(container);
    _._loadVimeoVideos(container);
  }
  
  this.onSectionUnload = function(container){
    _._unloadYoutubeVideos(container);
    _._unloadVimeoVideos(container);
  }
}

// Youtube API callback
function onYouTubeIframeAPIReady() {
  theme.VideoManager.youtubeApiReady();
}

// Manage option dropdowns
theme.OptionManager = new function(){
  var _ = this;

  _.selectors = {
    container: '.product',
    gallery: '.product-photos',
    priceArea: '.theme-price',
    submitButton: 'input[type=submit], button[type=submit]',
    multiOption: '.option-selectors'
  };
  
  _.strings = {
    priceNonExistent: "Unavailable",
    priceSoldOut: '<span class="money">[PRICE]</span> <span class="productlabel soldout"><span>'+"Out of stock"+'</span></span>',
    buttonDefault: "Add to cart",
    buttonNoStock: "Out of stock",
    buttonNoVariant: "Unavailable"
  };
  
  _._getString = function(key, variant){
    var string = _.strings[key];
    if(variant) {
      string = string.replace('[PRICE]', '<span class="theme-money">'+Shopify.formatMoney(variant.price, ml_money_format || theme.money_format)+'</span>');
    }
    return string;
  }
  
  _.getProductData = function($form) {
    return theme.productData[$form.data('product-id')];
  }
  
  _.addVariantUrlToHistory = function(variant) {
    if(variant) {
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    }
  }
  
  _.updateSku = function(variant, $container){
    $container.find('.sku .sku__value').html( variant ? variant.sku : '' );
    $container.find('.sku').toggleClass('sku--no-sku', !variant || !variant.sku);
  }
  
  _.updateBarcode = function(variant, $container){
    $container.find('.barcode .barcode__value').html( variant ? variant.barcode : '' );
    $container.find('.barcode').toggleClass('barcode--no-barcode', !variant || !variant.barcode);
  }
  
  _.updateBackorder = function(variant, $container){
    var $backorder = $container.find('.backorder');
    if($backorder.length) {
      if (variant.available) {
        if (variant.inventory_management && variant.inventory_quantity <= 0) {
          var productData = _.getProductData($backorder.closest('form'));
          $backorder.find('.selected-variant').html(productData.title + (variant.title.indexOf('Default') >= 0 ? '' : ' - '+variant.title) );
          $backorder.show();
        } else {
          $backorder.hide();
        }
      } else {
        $backorder.hide();
      }
    }
  }
  
  _.updatePrice = function(variant, $container) {
    var $priceArea = $container.find(_.selectors.priceArea);
    $priceArea.removeClass('on-sale');
    
    if(variant && variant.available == true) {
      var $newPriceArea = jQuery('<div>');
      if(variant.compare_at_price > variant.price) {
        jQuery('<span class="was-price theme-money">').html(Shopify.formatMoney(variant.compare_at_price, ml_money_format || theme.money_format)).appendTo($newPriceArea);
        $newPriceArea.append(' ');
        $priceArea.addClass('on-sale');
      }
      jQuery('<span class="current-price theme-money">').html(Shopify.formatMoney(variant.price, ml_money_format || theme.money_format)).appendTo($newPriceArea);
      $priceArea.html($newPriceArea.html());
    } else {
      if(variant) {
        $priceArea.html(_._getString('priceSoldOut', variant));
      } else {
        $priceArea.html(_._getString('priceNonExistent', variant));
      }
    }
  }
  
  _._updateButtonText = function($button, string, variant) {
    $button.each(function(){
      var newVal;
      newVal = _._getString('button' + string, variant);
      if(newVal !== false) {
        if(jQuery(this).is('input')) {
          jQuery(this).val(newVal);
        } else {
          jQuery(this).html(newVal);
        }
      }
    });
  }
  
  _.updateButtons = function(variant, $container) {
    var $button = $container.find(_.selectors.submitButton);
    
    if(variant && variant.available == true) {
      $button.removeAttr('disabled');
      _._updateButtonText($button, 'Default', variant);
    } else {
      $button.attr('disabled', 'disabled');
      if(variant) {
        _._updateButtonText($button, 'NoStock', variant);
      } else {
        _._updateButtonText($button, 'NoVariant', variant);
      }
    }

    
  }
  
  _.initProductOptions = function(originalSelect) {
    jQuery(originalSelect).not('.theme-init').addClass('theme-init').each(function(){
      var $originalSelect = jQuery(this);
      var productData = _.getProductData($originalSelect.closest('form'));
      
      // change state for original dropdown
      $originalSelect.on('change.themeProductOptions', function(e, variant){
        if(jQuery(this).is('input[type=radio]:not(:checked)')) {
          return; // handle radios - only update for checked
        }
        var variant = variant;
        if(!variant && variant !== false) {
          for(var i=0; i<productData.variants.length; i++) {
            if(productData.variants[i].id == jQuery(this).val()) {
              variant = productData.variants[i];
            }
          }
        }
        var $container = jQuery(this).closest(_.selectors.container);
        
        // update buttons
        _.updateButtons(variant, $container);
        
        // update price (after button, in case price is in button)
        _.updatePrice(variant, $container);

        // variant images
        if (variant && variant.featured_image) {
          $container.find(_.selectors.gallery).trigger('variantImageSelected', variant);
        }

        // extra details
        _.updateBarcode(variant, $container);
        _.updateSku(variant, $container);
        _.updateBackorder(variant, $container);

        // variant urls
        var $form = jQuery(this).closest('form');
        if($form.data('enable-history-state')) {
          _.addVariantUrlToHistory(variant);
        }

        // multi-currency
        
        if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {mlvedaload();}  
      });

      // split-options wrapper
      $originalSelect.closest(_.selectors.container).find(_.selectors.multiOption).on('change.themeProductOptions', 'select', function(){
        var selectedOptions = [];
        jQuery(this).closest(_.selectors.multiOption).find('select').each(function(){
          selectedOptions.push(jQuery(this).val());
        });
        // find variant
        var variant = false;
        for(var i=0; i<productData.variants.length; i++) {
          var v = productData.variants[i];
          var matches = true;
          for(var j=0; j<selectedOptions.length; j++) {
            if(v.options.indexOf(selectedOptions[j]) < 0) {
              matches = false;
            }
          }
          if(matches) {
            variant = v;
            break;
          }
        }
        // trigger change
        if(variant) {
          $originalSelect.val(variant.id);
        }
        $originalSelect.trigger('change', variant);
      });
      
      // first-run
      $originalSelect.trigger('change');
    });
  }
  
  _.unloadProductOptions = function(originalSelect) {
    jQuery(originalSelect).each(function(){
      jQuery(this).off('.themeProductOptions');
      jQuery(this).closest(_.selectors.container).find(_.selectors.multiOption).off('.themeProductOptions');
    });
  }
}

theme.SlideshowSection = new function(){
  this.onSectionLoad = function(target){
    jQuery('.slideshow', target).each(function(){
      jQuery(this).slick({
        autoplay: jQuery(this).hasClass('auto-play'),
        fade: jQuery(this).data('transition') == 'fade',
        infinite: true,
        useTransform: true,
        adaptiveHeight: true,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev">'+theme.icons.chevronLightLeft+'</button>',
        nextArrow: '<button type="button" class="slick-next">'+theme.icons.chevronLightRight+'</button>',
        autoplaySpeed: 10000, // milliseconds to wait between slides7000
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true
            }
          }
        ]
      });
    });
  }
  
  this.onSectionUnload = function(target){
    jQuery('.slick-slider', target).slick('unslick');
  }
  
  this.onBlockSelect = function(target){
    jQuery(target).closest('.slick-slider')
      .slick('slickGoTo', jQuery(target).data('slick-index'))
      .slick('slickPause');
  }
  
  this.onBlockDeselect = function(target){
    jQuery(target).closest('.slick-slider')
      .slick('slickPlay');
  }
}

theme.FeaturedCollectionSection = new function(){
  this.onSectionLoad = function(target){
    jQuery(window).trigger('checkcaptionheights');
  }
}

theme.BannerIndexSection = new function(){
  this.onSectionLoad = function(target) {
    var target = target;
    theme.checkForBannerBehindHeader();
    
    theme.SlideshowSection.onSectionLoad(target);
    
    jQuery('.slide:first').imagesLoaded(function(a,b){
      jQuery('#page-banner').addClass('show-contents');
    });
    
    jQuery('.fixed-height .slide img', target).willFillParent({ closest: '.slide', windowEvent: 'debouncedresize' });
  }
  
  this.onSectionUnload = function(target) {
    theme.SlideshowSection.onSectionUnload(target);
    jQuery(window).off('.willFillParent');
  }
  this.onBlockSelect = theme.SlideshowSection.onBlockSelect;
  this.onBlockDeselect = theme.SlideshowSection.onBlockDeselect;
}

theme.ProductTemplateSection = new function(){
  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);
    theme.OptionManager.initProductOptions(jQuery('select[name="id"]', target));
    jQuery(window).trigger('checkcaptionheights');
  }
  
  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);
    theme.OptionManager.unloadProductOptions(jQuery('select[name="id"]', target));
  }
}

theme.CollectionTemplateSection = new function(){
  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);
    
    // Sorting
    var $sortBy = jQuery('#sort-by', target);
    if($sortBy.length > 0) {
      queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      $sortBy.val($sortBy.data('initval')).trigger('change').on('change', function() {
        queryParams.sort_by = jQuery(this).val();
        location.search = $.param(queryParams);
      });
    }
    
    jQuery('#filter-tag', target).on('change', function(){
      window.location = jQuery(this).val();
    });
    
    jQuery(window).trigger('checkcaptionheights');
  }
  
  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);
    
    jQuery('#sort-by', target).off('change');
    jQuery('#filter-tag', target).off('change');
  }
}

theme.ListCollectionsTemplateSection = new function(){
  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);
    jQuery(window).trigger('checkcaptionheights');
  }
  
  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);
  }
}

theme.NothingButAHeaderImageSection = new function(){
  this.onSectionLoad = theme.loadPageHeaderImage;
  this.onSectionUnload = theme.unloadPageHeaderImage;
}

theme.HeaderSection = new function(){
  this.onSectionLoad = function(target){
    /// Child-navigation
    jQuery('#main-menu .main-menu-links > li > ul', target).parent().addClass('has-children')
      .append('<span class="child-indicator">' + theme.icons.chevronDown + '</span>') // dropdown icon
      .children('a').attr('aria-haspopup', 'true'); // ie touchscreens
    
    /// Newsletter interactions to show
    if(jQuery('.signup-section .error, .signup-section .success', target).length > 0) {
      jQuery('body').addClass('open-menu');
    }
  }
  
  this.onSectionUnload = function(target){
  }
}

theme.InstagramSection = new function(){
  this.onSectionLoad = function(target){
    jQuery('.willstagram:not(.willstagram-placeholder)', target).each(function(){
      var user_id = jQuery(this).data('user_id');
      var tag = jQuery(this).data('tag');
      var access_token = jQuery(this).data('access_token');
      var count = jQuery(this).data('count') || 10;
      var $willstagram = jQuery(this);
      var url = '';
      if(typeof user_id != 'undefined') {
        url = 'https://api.instagram.com/v1/users/' + user_id + '/media/recent?count='+count;
      } else if(typeof tag != 'undefined') {
        url = 'https://api.instagram.com/v1/tags/' + tag + '/media/recent?count='+count;
      }
      $.ajax({
        type: "GET",
        dataType: "jsonp",
        cache: false,
        url: url
        + (typeof access_token == 'undefined'? '' : ('&access_token='+access_token)),
        success: function(res) {
          if(typeof res.data != 'undefined') {
            var $itemContainer = jQuery('<div class="items">').appendTo($willstagram);
            var limit = Math.min(20, res.data.length);
            for(var i = 0; i < limit; i++) {
              var photo_url = res.data[i].images.standard_resolution.url.replace('http:', '');
              var link = res.data[i].link;
              var caption = res.data[i].caption != null ? res.data[i].caption.text : '';
              $itemContainer.append(jQuery('<div class="column fifth bleed item"><a target="_blank" href="'+link+'"><img src="'+photo_url+'" /></a><div class="desc">'+caption+'</div></div>'));
            }
          } else if(typeof res.meta !== 'undefined' && typeof res.meta.error_message !== 'undefined') {
            $willstagram.append('<div class="willstagram__error">'+res.meta.error_message+'</div>');
          }
        }
      });
      if(typeof jQuery(this).data('account') != 'undefined') {
        var splSel = jQuery(this).data('account').split('|');
        var $account = jQuery(this).closest(splSel[0]).find(splSel[1]);
        $.ajax({
          type: "GET",
          dataType: "jsonp",
          url: 'https://api.instagram.com/v1/users/self/?access_token='+access_token,
          success: function(res) {
            if(typeof res.data != 'undefined') {
              jQuery('<a>').html('@'+res.data.username).attr({
                href: 'https://www.instagram.com/'+res.data.username,
                target: '_blank'
              }).appendTo($account);
            }
          }
        });
      }
    });
  }
}

theme.CartTemplateSection = new function(){
  this.onSectionLoad = function(target){
    theme.loadPageHeaderImage(target);
    // terms and conditions checkbox
    if(jQuery('#cartform input#terms', target).length > 0) {
      jQuery(document).on('click.cartTemplateSection', '#cartform [name="checkout"]:submit, .additional-checkout-buttons :submit, .additional-checkout-buttons input[type=image], a[href="/checkout"]', function() {
        if(jQuery('#cartform input#terms:checked').length == 0) {
//           alert("You must agree to the terms and conditions before continuing.");
          return false;
        }
      });
    }
  }
  
  this.onSectionUnload = function(target){
    theme.unloadPageHeaderImage(target);
    jQuery(document).off('.cartTemplateSection');
  }
}

// A generic text notification above an element
theme.showQuickPopup = function(message, $origin){
  var $popup = jQuery('<div class="simple-popup"/>');
  var offs = $origin.offset();
  $popup.html(message).css({ 'left':offs.left, 'top':offs.top }).hide();
  jQuery('body').append($popup);
  $popup.css('margin-top', - $popup.outerHeight() - 10);
  $popup.fadeIn(200).delay(3500).fadeOut(400, function(){
    jQuery(this).remove();
  });
}

jQuery(function($){
  /// Persistent events for nav interaction
  
  jQuery(document).on('click', '.main-menu-toggle',function(e){
    jQuery('body').toggleClass('open-menu');
    e.preventDefault();
  });
  
  jQuery(document).on('click touchstart touchend', 'body.open-menu', function(e){
    if(e.target == this) {
      jQuery(this).removeClass('open-menu');
      e.preventDefault();
    }
  });
  
  jQuery(document).on('click', '#main-menu-signup-toggle', function(){
    jQuery('#main-menu-signup').toggleClass('expanded');
    return false;
  });
  
  jQuery(document).on('click', '#main-menu li.has-children > a', function(){
    jQuery(this).parent().toggleClass('expanded').hasClass('expanded')
    return false;
  });
  
  /// Button to scroll to the top
  jQuery(window).on('scroll', function(){
    jQuery('body').toggleClass('reveal-scroll-top', jQuery(window).scrollTop() > 500);
  });
  jQuery(document).on('click', '#scroll-top', function(e){
    e.preventDefault();
    jQuery('html:not(:animated),body:not(:animated)').animate({ scrollTop: 0}, 500 );
  });
    
  /// Toggle mini-menu search
//   jQuery(document).on('click', '.header_search', function(e){
//     if(jQuery(window).width() > 767) {
//       e.preventDefault();
//       if( jQuery('#pageheader').toggleClass('search-open').hasClass('search-open') ) {
//         setTimeout(function(){
//           jQuery('#pageheader .header-search input[type=text]').focus();
//         }, 500);
//       }
//     }
//   });
  
  jQuery(document).ready(function(){
    jQuery(document).on('click', '.header_search', function(e){
      e.preventDefault();
      if( jQuery('#pageheader').toggleClass('search-open').hasClass('search-open') ) {
        setTimeout(function(){
          jQuery('#pageheader .header-search input[type=text]').focus();
        }, 500);
      }
    });
  });
  
  /// Gallery
  // variant images
  jQuery(document).on('variantImageSelected', '.product-photos', function(e, data){
    // get image src
    var variantSrc = data.featured_image.src.split('?')[0].replace(/http[s]?:/, '');

    // locate matching thumbnail & click it
    var $thumb = jQuery(this).find('.thumbnails a[href^="' + variantSrc + '"]:first');
    $thumb.trigger('click');
  });
  // click a thumbnail
  jQuery(document).on('click', '.product-photos .thumbnails .thumb', function(e){
    
    e.preventDefault();
    var $photoCont = jQuery(this).closest('.product-photos');
    var $imgToChange = $photoCont.find('.main img');
    if($imgToChange.attr('alt', jQuery(this).attr('title')).fadeToAnotherImage(jQuery(this).find('img'))) {
      $photoCont.find('.main a').attr({ href: jQuery(this).attr('href'), title: jQuery(this).attr('title') });
      jQuery(this).addClass('active').siblings('.active').removeClass('active');
    }
  });
  // Expand all thumbs into large images
  jQuery(document).on('click', '.product-photos .load-all-thumbs', function(){
    var $cont = jQuery(this).closest('.product-photos').addClass('expanded-all');
    var $thumbs = $cont.find('.thumbnails');
    // Do we have lightboxes?
    var usingLightbox = $cont.find('.main a').length > 0;
    // Revert main image to first thumbnail
    $thumbs.find('.thumb:first').click();
    // Expanded image container
    var $expandedCont = jQuery('<div class="exp-image-container loading-img">').appendTo($cont);
    // Create expanded images
    $thumbs.find('.thumb:not(:first)').each(function(index){
      var $img = jQuery('<img>').attr({
        src: jQuery(this).find('img').data('mainsrc')
      });
      var $row = jQuery('<div class="main exp-image">');
      if(usingLightbox) {
        $row.append( jQuery('<a/>').attr({ href: jQuery(this).attr('href'), title: jQuery(this).attr('title') }).append($img) );
      } else {
        $row.append($img);
      }
      $row.appendTo($expandedCont);
    });
    // Initial height
    $expandedCont.css('height', $thumbs.height());
    // Remove thumbs
    $thumbs.remove();
    // Wait until loaded, then reveal
    $expandedCont.imagesLoaded(function(){
      var $lastChild = $expandedCont.children().last();
      $expandedCont.css('height', $lastChild.position().top + $lastChild.outerHeight());
      setTimeout(function(){
        $expandedCont.addClass('loaded').css('height', '');
      }, 1000); // post-transition
    });
    return false;
  });
  // Click on main image
  jQuery(document).on('click', '.product-photos .main a', function(e){
    e.preventDefault();
    //Don't do anything if the screen isn't very tall, otherwise, lightbox!
    if(jQuery(window).height() >= theme.lightbox_min_window_height && jQuery(window).width() >= theme.lightbox_min_window_width) {
      var $prodPhotoCont = jQuery(this).closest('.product-photos');
      if($prodPhotoCont.find('img').length == 1) {
        //One image only?
        $.colorbox({ href: jQuery(this).attr('href'), maxWidth: '94%' });
      } else {
        //Many images. Dupe thumbs to create a faux-gallery
        var imgSel = $prodPhotoCont.find('.main').length > 1 ? '.main' : '.thumbnails';
        jQuery('#gallery-cont').remove();
        var $galleryCont = jQuery('<div id="gallery-cont"/>').append(
          $prodPhotoCont.find(imgSel).find('a:has(img)').clone().attr({ rel: 'gallery', title: '' })
        ).hide().appendTo('body');
        //Trigger box (on the right one)
        $galleryCont.children().colorbox({maxWidth:'94%'}).filter('[href="'+jQuery(this).attr('href')+'"]').first().click();
      }
    }
  });


  //Ajax add-to-cart
  var shopifyAjaxAddURL = '/cart/add.js';
  var shopifyAjaxCartURL = '/cart.js';
  var shopifyAjaxStorePageURL = '/search';

  jQuery(document).on('submit', 'form[action="/cart/add"]:not(.noAJAX)', function(e) {
    var $form = jQuery(this);
    //Disable add button
    $form.find(':submit').attr('disabled', 'disabled').each(function(){
      var contentFunc = jQuery(this).is('button') ? 'html' : 'val';
      jQuery(this).data('previous-value', jQuery(this)[contentFunc]())[contentFunc]("Adding...");
    });

    //Add to cart
    $.post(shopifyAjaxAddURL, $form.serialize(), function(itemData) {
      //Enable add button
      $form.find(':submit').each(function(){
        $btn = jQuery(this);
        var contentFunc = jQuery(this).is('button') ? 'html' : 'val';
        //Set to 'DONE', alter button style, wait a few secs, revert to normal
        $btn[contentFunc]("Added to cart");
        setTimeout(function(){
          $btn.removeAttr('disabled')[contentFunc]($btn.data('previous-value'));
        }, 4000);
      });

      //Update header summary
      $.get(shopifyAjaxStorePageURL, function(data){


          var $newDoc = jQuery($.parseHTML('<div>' + data + '</div>'));
          var sels = ['#pageheader .header-mini-menu'];
          for(var i=0; i<sels.length; i++) {
            var cartSummarySelector = sels[i];
            var $newCartObj = $newDoc.find(cartSummarySelector);
            var $currCart = jQuery(cartSummarySelector);
            $currCart.replaceWith($newCartObj);
          }
          
          if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {mlvedaload();}  

          //Show cart dropdown for a few seconds
          var $col = jQuery('#pageheader .checkout-link').addClass('reveal');
          setTimeout(function(){
            $col.removeClass('reveal');
          }, 4000);
       
        
      });


    }, 'text').error(function(data) {
      //Enable add button
      var $firstBtn = $form.find(':submit').removeAttr('disabled').each(function(){
        var $btn = jQuery(this);
        var contentFunc = $btn.is('button') ? 'html' : 'val';
        $btn[contentFunc]($btn.data('previous-value'))
      }).first();

      //Not added, show message
      if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
        var jsonRes = $.parseJSON(data.responseText);
        theme.showQuickPopup(jsonRes.description, $firstBtn);
      } else {
        //Some unknown error? Disable ajax and submit the old-fashioned way.
        $form.addClass('noAJAX');
        $form.submit();
      }
    });
    return false;
  });

  /// General lightbox for all
  jQuery('a[rel=lightbox]').colorbox({ maxWidth: '94%' });
  
  /// Galleries (only on large screens)
  if(jQuery(window).height() >= theme.lightbox_min_window_height && jQuery(window).width() >= theme.lightbox_min_window_width) {
    jQuery('a[rel="gallery"]').colorbox({rel:'gallery',maxWidth:'94%'});
  }

  /// Immmediately select contents when focussing on some inputs
  jQuery(document).on('focusin click', 'input.select-on-focus', function(){
    jQuery(this).select();
  }).on('mouseup', 'input.select-on-focus', function(e){
    e.preventDefault(); //Prevent mouseup killing select()
  });

  /// Product blocks should have consistent heights
  jQuery(window).on('load debouncedresize checkcaptionheights', function(){
    var $firstBlock = jQuery('.prod-block:first').first();
    var productsPerRow = Math.round($firstBlock.parent().width() / $firstBlock.width());

    var $caps = jQuery('.prod-caption');    
    for(var i = 0; i < Math.ceil($caps.length / productsPerRow); i++) {
      var $toProcess = $caps.slice(i*productsPerRow, (i+1)*productsPerRow);
      var h = 0;
      $toProcess.each(function(){
        var ch = jQuery(this).children().outerHeight();
        if(ch > h) h = ch;
      }).height(h);
    }
  }).trigger('checkcaptionheights');

  
  /// Sticky nav
  var scrollTopLast = 0;
  jQuery(window).on('scroll',function(){
    var scrollTopNow = jQuery(this).scrollTop();
    var $pageheader = jQuery('#pageheader');
    // Reveal sticky nav on scroll-up
    if(scrollTopNow > 100 && scrollTopNow > scrollTopLast) {
      //Scroll down
      $pageheader.addClass('undock');
    } else if(scrollTopNow < scrollTopLast) {
      //Scroll up
      $pageheader.removeClass('undock');
    }
    scrollTopLast = scrollTopNow;
  });
  
   jQuery(document).on('click', '.ssw-reviews-caption.ssw-right-top', function(){
    jQuery(".ssw-reviews-widget.ssw-right-top").addClass("hasSomething");
  });
  jQuery(document).on('click', '.ssw-reviews-widget .ssw-review-side-backdrop', function(){
    jQuery(".ssw-reviews-widget.ssw-right-top").removeClass("hasSomething");
  });

  
  
  /// Register all sections
  theme.Sections.init();
  theme.Sections.register('header', theme.HeaderSection);
  theme.Sections.register('banner-index', theme.BannerIndexSection);
  theme.Sections.register('slideshow', theme.SlideshowSection);
  theme.Sections.register('video', theme.VideoManager);
  theme.Sections.register('featured-collection', theme.FeaturedCollectionSection);
  theme.Sections.register('instagram', theme.InstagramSection);
  theme.Sections.register('product-template', theme.ProductTemplateSection);
  theme.Sections.register('cart-template', theme.CartTemplateSection);
  theme.Sections.register('collection-template', theme.CollectionTemplateSection);
  theme.Sections.register('search-template', theme.NothingButAHeaderImageSection);
  theme.Sections.register('blog-template', theme.NothingButAHeaderImageSection);
  theme.Sections.register('article-template', theme.NothingButAHeaderImageSection);
  theme.Sections.register('page-template', theme.NothingButAHeaderImageSection);
  theme.Sections.register('page-contact-template', theme.NothingButAHeaderImageSection);
  theme.Sections.register('page-list-collections-template', theme.ListCollectionsTemplateSection);
  theme.Sections.register('list-collections-template', theme.ListCollectionsTemplateSection);
});

//Gtranslate modification: necessary to translate some phrases in JS response.
var gt_lang = document.querySelector("html").getAttribute('lang') || "en";
function replaceWithTranslation() {
setTimeout(function(){
	var gt_bn_elem = document.querySelector("#gt_txt_buy_now"),
		gt_bw_elem = document.querySelector("#gt_txt_buy_paypal"),
		gt_options_elem = document.querySelector("#gt_txt_other_po"),
		pbn_btn 	= document.querySelector('.shopify-payment-button button.shopify-payment-button__button'),
		pbn_gp_btn 	= document.querySelector('.shopify-payment-button div.shopify-payment-button__button span:nth-child(2)'),
		pmo_btn 	= document.querySelector('.shopify-payment-button .shopify-payment-button__more-options');

	if(pbn_gp_btn) { //Pay With button
      pbn_gp_btn.innerHTML = gt_bw_elem.innerHTML;
    } else {
      gt_bn_elem && pbn_btn && (pbn_btn.innerHTML = gt_bn_elem.innerHTML);  //Buy now btn
    }	
	gt_options_elem && pmo_btn && (pmo_btn.innerHTML = gt_options_elem.innerHTML);  //More Options
	
	
	jQuery.ajax({"url":"/checkout.json?locale="+gt_lang})
 }, 1500); 
}

if(gt_lang != "en") {
	var payButtons 	= document.querySelector('.shopify-payment-button');
	var config 		= { attributes: false, childList: true, subtree: false };
	var callback = function(mutationsList, observer) {
	  for(var mutation of mutationsList) {
		if (mutation.type == 'childList') {
		  replaceWithTranslation();
		}
	  }
	};
	// Create an observer instance linked to the callback function
	var gt_observer = new MutationObserver(callback);

	// Start observing the target node for configured mutations
	payButtons && gt_observer.observe(payButtons, config);
}



/* 
NexusMedia EasyTabs Fixes - Aug 19, 2020
*/

document.addEventListener('easytabs_page_inited', function(event){   
    const data_handle = "tabs-description";
  	const tabs_item = $("div.easytabs-container").find(`div[data-et-handle='${data_handle}']`);  // новый синтаксис для использование переменных 
    if(!$(tabs_item).hasClass('easytabs-active')){
      	$(tabs_item).addClass('easytabs-active');
    }
});


/* Custom Slider for collection list Home Page*/
$('.collection-list-slider .owl-carousel').owlCarousel({
  loop: true,
  margin: 0,
  nav: true,
  dots:false,
  navText: [
    theme.icons.chevronLightLeft,
    theme.icons.chevronLightRight
  ],
  responsive: {
    0: {
      items: 2,
//       dots:true,
//       nav:false
    },
    420: {
      items: 2,
//       dots:true,
//       nav:false
    },
    1024: {
      items: 3
    },
    1200: {
      items: 4
    }
  }
});

/* Ends here */

// New Mobile Menu JS
$(document).ready(function(){

  //   if( $(".menuParent > li").children('ul.menuParent').length > 0 ){
  //     //     $(".menuParent > li").children('ul').children('li').children("ul").parent().addClass('has-children');
  //     $(".menuParent > li").children('ul.menuParent').children('li').addClass('has-children');
  //   }

  $("ul.menuParentTop").each(function(){
    if($(this).data("menu-handle")){
      $(this).parent().addClass("has-children")
    }
  });

  function backEvent(mainParent, globalParent, target){
    $(target).parent().removeClass('has-clicked');
    $(target).parent().parent().removeClass('expanded');
    $(target).parent().parent().parent().removeClass('children-clicked');

    if($('.main-menu-links.mldmob').hasClass('children-clicked')){
      $('.extrasForMain').fadeOut(550);
    }else{	
      $('.extrasForMain').fadeIn(750);
    }
  }


  function recursiveEvent(mainParent, globalParent, target){
    $('.extrasForMain').fadeOut(550);
    //     $(target).addClass('active-1');
    //     $(mainParent).find('ul').removeClass('has-clicked');
    //     $(globalParent).removeClass('children-clicked');
    $(target).children('ul').addClass('has-clicked'); // For the  child List
    $(target).parent().addClass('children-clicked'); // for the parent   

    //     $(target).children('ul').children('li').addClass('subChild');
    //     $(target).find("ul").addClass('grandChild'); // for the parent
    //     $(target).children('ul').children('li').children("ul").addClass('grandChild'); // for the parent
    //     $(target).parents('ul').removeClass('grandChild');
  }

  $('.menuParent > li.has-children').click(function(e){
    recursiveEvent('.menuParent > li.has-children', ".menuParent", this);
  });

  $('.menuParentTop > li.has-children').click(function(e){
    //     $(this).addClass('expanded');
    recursiveEvent('.menuParentTop > li.has-children', ".menuParentTop", this);
  });

  $('.back-btn').click(function(e){
    e.stopPropagation();
    backEvent('.menuParent > li', ".menuParent", this)
    //     $(".main-menu-links.mldmob li.has-children").find('ul').removeClass('has-clicked');
    //     $(".main-menu-links.mldmob li.has-children").removeClass('expanded');
    //     $(".main-menu-links.mldmob").removeClass('children-clicked');  
  });
  
// /* Custom Slider for collection list Home Page*/
// $('.collection-list-slider .owl-carousel').owlCarousel({
//   loop: true,
//   margin: 0,
//   nav: true,
//   dots:false,
//   navText: [
//     theme.icons.chevronLightLeft,
//     theme.icons.chevronLightRight
//   ],
//   responsive: {
//     0: {
//       items: 2,
// //       dots:true,
// //       nav:false
//     },
//     420: {
//       items: 2,
// //       dots:true,
// //       nav:false
//     },
//     1024: {
//       items: 3
//     },
//     1200: {
//       items: 4
//     }
//   }
// });
  var homePageSlider = $('.homepage-products.owl-carousel'),
      settings = { 
        loop: true,
        margin: 5,
        nav: true,
        dots:false,
        navText: [
          theme.icons.chevronLightLeft,
          theme.icons.chevronLightRight
        ],
        responsive: {
          0: {
            items: 2,
          }         
        }
      }  
  var owl = $('.featured-images .owl-carousel'),
      owlOptions = {
        loop: false,
        nav:true,
        dots:false,
        margin: 10,
        navText: [
          theme.icons.chevronLightLeft,
          theme.icons.chevronLightRight
        ],
        responsive: {            
          0: {
            items: 1,
          },
          420: {
            items: 2,
          }            
        }
      };

  if ( $(window).width() < 768 ) {
    var owlActive = owl.owlCarousel(owlOptions);
    var homePageSliderActive =  homePageSlider.owlCarousel(settings);

  } else {
    owl.addClass('off');
    homePageSlider.addClass('off');

  }

  $(window).resize(function() {
    if ( $(window).width() < 768 ) {
      if ( $('.owl-carousel').hasClass('off') ) {
        var owlActive = owl.owlCarousel(owlOptions);
        owl.removeClass('off');

        var homePageSliderActive =  homePageSlider.owlCarousel(settings);
        homePageSlider.removeClass('off');

      }
    } else {
      if ( !$('.owl-carousel').hasClass('off') ) {
        owl.addClass('off').trigger('destroy.owl.carousel');
        owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
        
        homePageSlider.addClass('off').trigger('destroy.owl.carousel');
        homePageSlider.find('.owl-stage-outer').children(':eq(0)').unwrap();
        
      }
    }
  });

});
